// extracted by mini-css-extract-plugin
export default {"wrap":"CopyBotMessageButton_wrap__WhhvU","button":"CopyBotMessageButton_button__obUkY","feedback":"CopyBotMessageButton_feedback__bAnBF"};